import Vue from 'vue';
/**
 * @param { string } value: 字符串
 * @return 正整数字符串
 */
function intNumber(value, len = 4) {
  return new Promise((resolve) => {
    if (value) {
      //只能输入正整数
      value = value.replace(/\D/g, '');
    }
    if (value == 0) {
      value = '';
    }
    //获取小数点前面的值
    if (value.indexOf('.') != -1) {
      let arr = value.split('.');
      let le = arr[0].length;
      if (le > 4) {
        value = arr[0].substring(0, len);
      }
    } else {
      value = value.slice(0, len);
    }
    return resolve(value);
  });
}

/**
 * @param { string } value: 字符串
 * @param { number } len: 要截取多少位小数
 * @return 一个浮点数
 */
function floatNumber(value, len) {
  return new Promise((resolve) => {
    if (value) {
      // if(value == 0 ){
      //   return resolve('');
      // }
      // if (isNaN(Number(value))) {
      //   return resolve('');
      // }
      value = value.replace(/[^\d\.]/g, '');
      // 判断是否还有小数点
      if (value.indexOf('.') != -1) {
        // 截取小数点后面的字符串
        let strLen = value.substring(value.indexOf('.') + 1);

        if (strLen.length >= len) {
          // 如果小数点后的位数大于要截取的
          value = value.substring(0, value.indexOf('.') + len + 1);
        } else {
          value = value.substring(0, value.indexOf('.') + strLen.length + 1);
        }
      }
      let arr = value.split('.');
      let beforeLen = arr[0].length;
      //获取小数点前面的值
      if (value.indexOf('.') != -1) {
        if (beforeLen > 6) {
          let int = arr[0].substring(0, 6);
          if (value.indexOf('.') > -1) {
            value = int + '.' + arr[1];
          } else {
            value = int;
          }
        }
      } else {
        if (beforeLen > 6) {
          value = arr[0].slice(0, 6);
        }
      }

      return resolve(value);
    }
  });
}
const inputNumber = {
  bind: function (el, binding) {
      const input = el.getElementsByTagName('input')[0] || el;
      //console.log('before', input.value);
      input.onkeyup = async function (e) {
        if (binding.value.type === 'int') {
          input.value = await intNumber(input.value, binding.value.number || 4)
        } else {
          input.value = await floatNumber(input.value, binding.value.number, binding.value.intNumber || 8)
        }
        // console.log('after', input.value);
        trigger(input, 'input')
      }
      input.onblur = async function (e) {
        if (binding.value.type === 'int') {
          input.value = await intNumber(input.value, binding.value.number || 4)
        } else {
          input.value = await floatNumber(input.value, binding.value.number, binding.value.intNumber || 8)
        }
        //console.log('after', input.value);
        trigger(input, 'input')
      }
    }

  // inserted: function(el, binding) {
  //   const input = el.getElementsByTagName('input')[0];
  //   input.oninput = async function(e) {
  //     if (binding.value.type === 'int') {
  //       let value = await intNumber(input.value, binding.value.number || 4)
  //       // value = isNaN(value) ? '' : value;
  //       console.log(value);
  //       input.value = input.value.replace(input.value, value);
  //       // console.log(input.value);
  //     } else {
  //       let value = await floatNumber(input.value, binding.value.number);
  //       // value = isNaN(value) ? '' : value;
  //       console.log(value);
  //       input.value = input.value.replace(input.value, value);
  //     }
  //     // trigger(input, 'input');
  //   };
  // },
  // inserted: function(el, binding) {
  //   const input = el.getElementsByTagName('input')[0];
  //   input.oninput = async function(e) {
  //     if (binding.value.type === 'int') {
  //       input.value = await intNumber(input.value, binding.value.number || 4);
  //     } else {
  //       input.value = await floatNumber(input.value, binding.value.number);
  //     }
  //   };
  // },
};

const trigger = (el, type) => {
  const e = document.createEvent('HTMLEvents');
  e.initEvent(type, true, true);
  el.dispatchEvent(e);
};

export default inputNumber;
